import clientAxios from "../config/axios";
import { types } from "../types";
import { errorAlert, successAlert } from "./alerts";
import { setLoading, removeLoading, closeModal } from "./ui";

export const getStudents = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get("/api/v1/students");
      // console.log(result)
      dispatch({
        type: types.getStudent,
        payload: result.data,
      });
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const getStudentById = (studentId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.get(`/api/v1/students/${studentId}`);
      console.log(result)
      dispatch({
        type: types.getStudentById,
        payload: result.data[0],
      });
    } catch (error) {
      console.log(error)

      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const createStudent = (student) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());

      const result = await clientAxios.post("/api/v1/students", student);
      dispatch({ type: types.createStudent, payload: result.data });

      dispatch(
        successAlert(`${result.statusText} Student Created`, result.status)
      );
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const updateStudent = (student) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      const result = await clientAxios.put(
        `/api/v1/students/${student._id}`,
        student
      );
      dispatch({
        type: types.updateStudent,
        payload: result.data,
      });

      dispatch(
        successAlert(` ${result.statusText} College Updated`, result.status)
      );
      dispatch(removeStudentToUpdating());
      dispatch(removeLoading()); // depronto moverlo
      dispatch(closeModal());
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

export const deleteStudent = (studentId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading());
      await clientAxios.delete(`/api/v1/students/${studentId}`);
      dispatch({ type: types.deleteStudent, payload: studentId });
    } catch (error) {
      dispatch(
        errorAlert(
          `${error.response.status} ${error.response.data.msg}`,
          error.response.status
        )
      );
    }
    dispatch(removeLoading());
  };
};

//Settings

export const setStudentToUpdating = (student) => {
  return (dispatch) => {
    dispatch({ type: types.setStudentToUpdate, payload: student });
  };
};
export const removeStudentToUpdating = () => {
  return (dispatch) => {
    dispatch({ type: types.removeStudentFromUpdate });
  };
};

export const setStudentToDeleting = (studentId) => {
  return (dispatch) => {
    dispatch({ type: types.setStudentToDelete, payload: studentId });
  };
};
export const removeStudentfromDeleting = () => {
  return (dispatch) => {
    dispatch({ type: types.removeStudentFromDelete });
  };
};

export const removeStudentById = () => {
  return (dispatch) => {
    dispatch({ type: types.removeStudentById });
  };
};
